import Styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { cssDeclaration, VALID_DIMENSION_DATA } from '../Utils';

export const RadialProgressContainer = Styled.div<{size?: VALID_DIMENSION_DATA}>`
  position: relative;

  ${({ theme: { themeTwo }, size }) => size && css`
    /* height */ ${cssDeclaration(themeTwo, 'height', size)};
  `}
`;

export const PercentagePath = Styled.path<{animationStyles: FlattenSimpleInterpolation}>`
  ${({ theme: { themeTwo }, animationStyles }) => css`
    /* stroke */ ${cssDeclaration(themeTwo, 'stroke', themeTwo.circleProgress.percentagePathColor)}
    ${animationStyles}
  `}
`;

export const BackgroundPath = Styled.path`
  ${({theme: { themeTwo }}) => css`
    /* stroke */ ${cssDeclaration(themeTwo, 'stroke', themeTwo.circleProgress.backgroundPathColor)}
  `}
`;
